import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { NuvraLogo } from "@/components/NuvraLogo";
import { ProjectSwitcher } from "@/components/ProjectSwitcher";
import { NotificationPanel } from "@/components/NotificationPanel";
import { useI18n } from "@/i18n/I18nContext";

export function TopBar() {
  const { t } = useI18n();
  const openPalette = () => {
    document.dispatchEvent(
      new KeyboardEvent("keydown", { key: "k", ctrlKey: true, bubbles: true })
    );
  };

  return (
    <header className="relative flex h-14 items-center justify-between border-b border-border/40 px-4 bg-background/80 backdrop-blur-lg sticky top-0 z-50">
      {/* Brand, centred like an elite product header: the name reads first, the mark
          beside it. Always present, so the founder always knows the company they are
          inside. Links home. */}
      <Link
        to="/dashboard"
        aria-label={t("topbar.home")}
        className="absolute left-1/2 -translate-x-1/2 z-10 flex items-center gap-2.5"
      >
        <NuvraLogo size={28} className="shrink-0" />
        <span className="text-[18px] font-semibold tracking-[-0.01em] gradient-text">Nuvra</span>
      </Link>

      {/* Left: just navigation. The wide search no longer lives here; it was reaching
          the centre and covering the brand on desktop. */}
      <div className="flex items-center gap-3">
        <SidebarTrigger className="text-muted-foreground hover:text-foreground transition-colors" />
        <div className="h-5 w-px bg-border/40 hidden sm:block" />
        <div className="hidden sm:block">
          <ProjectSwitcher />
        </div>
      </div>

      {/* Right: the notification bell (real per-user inbox + phone push opt-in) and
          the command palette as compact icons, so they can never overlap the centred
          brand. The bell stays available on mobile so alerts are always reachable. */}
      <div className="flex items-center gap-1">
        <NotificationPanel />
        <button
          onClick={openPalette}
          aria-label={t("topbar.searchAria")}
          title={t("topbar.searchTitle")}
          className="hidden sm:flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
        >
          <Search className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}
